import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: {},
    token: null
  },
  getters: {
    isLoggedIn: state => state.token,
    user: state => state.user,
    role: state => state.user.role,
    // token: state => localStorage.getItem('jwt')
    token: state => state.token
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    login(state, payload) {
      state.token = payload.token;
      state.user = payload.user;
      Vue.axios.defaults.headers.common = {
        Authorization: `Bearer ${state.token}`
      };
    },
    setUser(state, payload) {
      if (payload.photo) {
        payload.photoUrl = payload.photo.url;
        if (process.env.NODE_ENV === "development") {
          payload.photoUrl = `${Vue.prototype.$API}${payload.photo.url}`;
        }
      }
      state.user = payload;
    },
    logout(state) {
      state.user = {};
      state.token = null;
      Vue.axios.defaults.headers.common = null;
      router.push("login");
    }
  },
  actions: {
    getUser({ state, commit }) {
      Vue.axios.get(`${Vue.prototype.$API}/users/me`).then(response => {
        commit("setUser", response.data);
      });
    }
  }
});
